import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTextTranslation } from '../utils/useBackendTranslation';
import BackendText from './BackendText';

const StatsCard = ({ 
  value, 
  label, 
  i18nKey,
  isBackendContent = false 
}) => {
  const { t } = useTranslation();
  
  // Always call the hook unconditionally
  const { translatedText: backendTranslatedLabel } = useTextTranslation(label);
  
  // Then decide which data to use based on the prop
  const translatedLabel = isBackendContent ? backendTranslatedLabel : null;
  
  // Determine what label to display (backend translation or i18n)
  const displayLabel = isBackendContent
    ? translatedLabel || label
    : i18nKey 
      ? t(i18nKey, { defaultValue: label }) 
      : label;
  
  return (
    <div className="group">
      <div className="border-2 border-white p-8 hover:bg-white hover:text-black transition-all duration-300">
        <div className="text-4xl font-black mb-2">{value}</div>
        <div className="text-sm uppercase tracking-widest font-medium opacity-80 group-hover:opacity-100">
          {isBackendContent ? (
            <BackendText
              text={label}
              i18nKey={i18nKey}
              fallback={label}
            />
          ) : (
            displayLabel
          )}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
